import styled from "styled-components";
import Col from "../../UIcomponent/Column";
import StyledButton from "../../UIcomponent/Button";

export const Layout = styled(Col)`
  display: ${(props) => (props.visible === true ? "flex" : "none")};
  position: fixed !important;
  top: 0px !important;
  bottom: 0px !important;
  left: 0px !important;
  right: 0px !important;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 100000000000000000000000000000;
  width: 100vw;
  height: 100vh;
  transition: transform 50ms cubic-bezier(0, 0, 0.2, 1) 0ms;
`;

export const Container = styled(Col)`
  display: ${(props) => (props.visible === true ? "flex" : "none")};
  width: 320px;
  height: 480px;
  box-shadow: ${(props) => props.shadowDark};
  flex-direction: column;
  background-color: white;
  border-radius: 20px;
  position: fixed !important;
  left: 50% !important;
  top: 50% !important;
  margin-left: -160px;
  margin-top: -240px;
  filter: blur(0px);
  z-index: 100000000000000000000000000001;
  -webkit-animation: appear 1s ease-in-out 0s 1 normal;
  -moz-animation: appear 1s ease-in-out 0s 1 normal;
  -ms-animation: appear 1s ease-in-out 0s 1 normal;
  animation: appear 1s ease-in-out 0s 1 normal;
  @-webkit-keyframes appear {
    0% {
      opacity: 0;
      -webkit-transform: scale3d(0.3, 0.3, 0.3);
      transform: scale3d(0.3, 0.3, 0.3);
    }
    60% {
      opacity: 1;
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  @keyframes appear {
    0% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
    60% {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }
  }
  @media screen and (max-width: 330px) {
    width: 290px;
    margin-left: -145px;
  }
`;
export const DesignWrapper = styled(Col)`
  display: ${(props) => (props.visible === true ? "flex" : "none")};
  width: 440px;
  height: 220px;
  box-shadow: ${(props) => props.shadowDark};
  border-radius: 20px;
  position: fixed !important;
  z-index: 100000000000000000000000000001;
  left: 50% !important;
  top: 50% !important;
  margin-left: -230px;
  margin-top: -330px;
  filter: blur(0px);
  svg {
    width: 420px;
    height: 220px;
  }
  -webkit-animation: appear 1s ease-in-out 0s 1 normal;
  -moz-animation: appear 1s ease-in-out 0s 1 normal;
  -ms-animation: appear 1s ease-in-out 0s 1 normal;
  animation: appear 1s ease-in-out 0s 1 normal;
  @-webkit-keyframes appear {
    0% {
      opacity: 0;
      -webkit-transform: scale3d(0.3, 0.3, 0.3);
      transform: scale3d(0.3, 0.3, 0.3);
    }
    60% {
      opacity: 1;
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  @keyframes appear {
    0% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
    60% {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }
  }
`;
export const Close = styled(Col)`
  background-color: white;
  width: 45px;
  height: 45px;
  box-shadow: ${(props) => props.theme.shadowDark};
  border-radius: 22.5px;
  position: absolute !important;
  top: 70px !important;
  right: 35px !important;
  cursor: pointer;
  z-index: 100000000000000000000000000004;
  svg {
    width: 15px;
    height: 15px;
  }
  @media screen and (max-width: 330px) {
    top: 70px !important;
    right: 65px !important;
  }
`;
export const Title = styled(Col)`
  font-family: "Fa_IRANSansBold";
  font-size: 2em;
  margin-top: 140px;
  color: ${(props) => props.theme.primary};
`;
export const Desc = styled(Col)`
  font-size: 1.4em;
  color: ${(props) => props.theme.text};
  margin: 25px 0px 15px 0px;
`;
export const Help = styled(Col)`
  font-size: 1em;
  color: ${(props) => props.theme.text};
  margin: 0px 0px 15px 0px;
`;
export const CodeContainer = styled(Col)`
  margin-top: 20px;
`;
export const CodeBox = styled.textarea`
  height: 55px;
  border: 2px dashed rgba(50, 50, 50, 0.45);
  padding: 8px 45px 5px 45px;
  border-radius: 2px;
  color: ${(props) => props.theme.primary};
  font-size: 1.6em;
  font-weight: 600;
  outline: none;
  width: 220px;
  display: flex;
  justify-content: center;
  text-align: center;
  font-family: "Fa_IRANSans";
  resize: none;
  overflow: auto;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
  @media screen and (max-width: 330px) {
    width: 180px;
  }
`;
export const CodeCopy = styled(Col)`
  justify-content: flex-start;
  width: 35px;
  height: 100%;
  svg {
    width: 25px;
    height: 25px;
    cursor: pointer;
    path {
      fill: ${(props) => props.copied === true && props.theme.secondary};
    }
  }
`;
export const Action = styled(StyledButton)`
  height: 40px;
  border-radius: 20px;
  width: 280px;
  margin-top: 40px;
  a {
    color: white;
  }
  @media screen and (max-width: 330px) {
    width: 240px;
  }
`;
